import { GoogleLogin } from "@react-oauth/google";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/auth.css";

function Register({ setUser }) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    gender: "",
    age: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ======================
  // NORMAL REGISTER
  // ======================
const handleRegister = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const data = await res.json();

    if (!res.ok) {
      if (data.error?.toLowerCase().includes("exist")) {
        alert("User already exists. Please login.");
        navigate("/login");
      } else {
        alert(data.error || "Registration failed");
      }
      return;
    }

    // ✅ SUCCESS
    alert("Registration successful! Please login.");
    navigate("/login");

  } catch (error) {
    console.error("Register error:", error);
    alert("Server error. Please try again.");
  }
};
  // ======================
  // GOOGLE REGISTER
  // ======================
  const googleRegister = async (res) => {
  try {
    const r = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/google`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: res.credential,
        gender: form.gender,
        age: form.age,
      }),
    });

    const data = await r.json();

    if (!r.ok) {
      if (data.error?.toLowerCase().includes("exist")) {
        alert("User already exists. Please login.");
        navigate("/login");
      } else {
        alert(data.error || "Google registration failed");
      }
      return;
    }

    alert("Google registration successful! Please login.");
    navigate("/login");

  } catch (error) {
    console.error("Google register error:", error);
    alert("Server error. Please try again.");
  }
};
  return (
    <div className="auth-page">
      <div className="auth-box">
        <h2>Create your account</h2>
        <p className="auth-desc">
          Register to apply for jobs and track applications
        </p>

        <form onSubmit={handleRegister}>
          <input
            name="name"
            placeholder="Full name"
            onChange={handleChange}
            required
          />

          <div className="auth-row">
            <select name="gender" onChange={handleChange} required>
              <option value="">Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>

            <input
              name="age"
              type="number"
              placeholder="Age"
              onChange={handleChange}
              required
            />
          </div>

          <input
            name="email"
            type="email"
            placeholder="Email address"
            onChange={handleChange}
            required
          />

          <input
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />

          <button type="submit">Create account</button>
        </form>

        <div className="auth-divider">
          <span>OR</span>
        </div>

        <div className="google-btn-wrapper">
          <GoogleLogin onSuccess={googleRegister} />
        </div>

        <div className="auth-footer">
          Already registered?
          <span onClick={() => navigate("/login")}> Login</span>
        </div>
      </div>
    </div>
  );
}

export default Register;
